import { VENUE, DELIVERY, PROMOTER, EVENTS, PDV, SCANNER, COUPON, TICKET_TEMPLATE, EVENT_GROUPS, ZONES, BANK, TERMINALS } from './screens/CatalogList';
import { Navigate, Outlet, createBrowserRouter, useRouteError } from 'react-router-dom';
import { useUser } from './AdminHooks';
import SeatmapEdit from './screens/venue/section/SeatmapEdit';
import UserContainer from './screens/user/UserContainer';
import Navigation from './Navigation';
import UserAccess from './UserAccess';
import {
	ActiveQueues,
	BankView,
	Catalog,
	Conciliacion,
	ConciliacionEventMethod,
	DatePayments,
	DatePaymentsList,
	DeliveryCreate,
	EventContainer,
	EventCreate,
	EventGroupCreate,
	EventList,
	OrderCreator,
	OrderList,
	OrderView,
	OriginsDay,
	Papeleta,
	PapeletaDay,
	PapeletaPdv,
	PaymentTerminalView,
	PayoutGroupView,
	PayoutList,
	PayoutView,
	PdvConciliaDetail,
	PdvConciliaList,
	PdvContainer,
	PdvCreate,
	PromoterContainer,
	RefundableRequest,
	RefundList, 
	RefundView,
	ReportsContainer,
	ScannerView,
	StatsReport,
	SystemConfig,
	TestScreen,
	TicketCreator,
	UserCreate,
	UserList,
	VenueCreate,
	ZoneContainer,
	ZoneView,
} from './screens';

const RouterComponent = ()=>{
	var { user, hasAccess } = useUser();

	var ErrorElement = ()=>{
		const error = (useRouteError() as any);
		return <div>
			<div className="fr centered header" style={{ fontSize: 100 }}>
				{error.status || '500'}
				<div className="sub header" style={{ fontSize: 20 }}>
					{error.status===404 ? 'Página no encontrada' : (
						hasAccess(UserAccess.ADMIN.DEVELOPER) ? error.message : 'Hubo un error inesperado.'
					)}
				</div>
			</div>
		</div>
	}

	const Router = createBrowserRouter([{
		path: '/',
		errorElement: <Navigation outlet={<ErrorElement />} />,
		element: <Navigation outlet={<Outlet />} />,
		children: [
			{ path: '/', element: <EventList /> }, 
			{ path: '/auth', element: <Navigate to={'/'} /> },
			{ path: '/stats', element: <StatsReport /> },
			// === EVENTS ===	
			{ path: '/events', element: <EventList /> },
			{ path: '/events/create', element: <EventCreate /> },
			{ path: '/events/refundable/:id', element: <RefundableRequest /> },
			{ path: '/events/:id/promotions/coupon/:coupon_id', element: <EventContainer /> },
			{ path: '/events/:id*', element: <EventContainer /> },
			// === USERS ===
			{ path: '/users', element: <UserList /> },
			{ path: '/users/create', element: <UserCreate /> },
			{ path: '/users/:id*', element: <UserContainer /> },
			// === ORDERS ===
			{ path: '/orders', element: <OrderList /> },
			{ path: '/orders/:hash', element: <OrderView /> },
			{ path: '/orders/create/:date', element: <OrderCreator /> },
			// === VENUE ===
			{ path: '/venues', element: <Catalog options={VENUE(user, hasAccess)} /> },
			{ path: '/venues/:venue_id', element: <VenueCreate /> },
			{ path: '/venues/:venue_id/sections/:section_id/seatmap', element: <SeatmapEdit /> },
			{ path: '/venues/:venue_id/sections/:section_id/seatmap/date/:date_id', element: <SeatmapEdit /> },
			// === CONCILIACION ===
			{ path: '/conciliacion', element: <Conciliacion /> },
			{ path: '/conciliacion/papeleta', element: <Papeleta /> },
			{ path: '/conciliacion/papeleta/:day', element: <PapeletaDay /> },
			{ path: '/conciliacion/papeleta/month/:day', element: <PapeletaDay month /> },
			{ path: '/conciliacion/papeleta/:day/pdv', element: <PapeletaPdv /> },
			{ path: '/conciliacion/origenes/:day', element: <OriginsDay /> },
			{ path: '/conciliacion/origenes/month/:day', element: <OriginsDay month /> },
			{ path: '/conciliacion/events/:event_id/:method_id', element: <ConciliacionEventMethod /> },
			{ path: '/conciliacion/tabla', element: <DatePaymentsList /> },
			{ path: '/conciliacion/tabla/:day', element: <DatePayments /> },
			// === DELIVERY METHODS ===
			{ path: '/c/delivery', element: <Catalog options={DELIVERY(user, hasAccess)} /> },
			{ path: '/c/delivery/:delivery_id', element: <DeliveryCreate /> },
			// === PROMOTERS ===
			{ path: '/promoters', element: <Catalog options={PROMOTER(user, hasAccess)} /> },
			{ path: '/promoters/:id*', element: <PromoterContainer /> },
			// === PDV ===
			{ path: '/pdv', element: <Catalog options={PDV(user, hasAccess)} /> },
			{ path: '/pdv/create', element: <PdvCreate /> },
			{ path: '/pdv/:id*', element: <PdvContainer /> },
			// === SCANNER ===
			{ path: '/scanners', element: <Catalog options={SCANNER(user, hasAccess)} /> },
			{ path: '/scanners/:scanner_id', element: <ScannerView /> },
			// === PAYOUTS ===
			{ path: '/payouts', element: <PayoutList /> },
			{ path: '/payouts/:id', element: <PayoutView /> },
			{ path: '/payouts/group/:id', element: <PayoutGroupView /> },
			// === REFOUND ===
			{ path: '/refunds', element: <RefundList /> },
			{ path: '/refunds/:id', element: <RefundView /> },
			// === TEMPLATES ===
			{ path: '/templates', element: <Catalog options={TICKET_TEMPLATE(user, hasAccess)} /> },
			{ path: '/templates/creator', element: <TicketCreator create /> },
			// === EVENT GROUPS ===
			{ path: '/parent', element: <Catalog options={EVENT_GROUPS(user, hasAccess)} /> },
			{ path: '/parent/:group_id', element: <EventGroupCreate /> },
			// === INVOICE ===
			// { path: '/invoice', element: <Catalog options={INVOICE(user, hasAccess)} /> },
			// === ZONES ===
			{ path: '/zones', element: <Catalog options={ZONES(user, hasAccess)} /> },
			{ path: '/zones/create', element: <ZoneView /> },
			{ path: '/zones/:id*', element: <ZoneContainer /> },
			// === BANKS ===
			{ path: '/banks', element: <Catalog options={BANK(user, hasAccess)} /> },
			{ path: '/banks/:bank_id', element: <BankView /> },
			// === CONCILIACION TAQUILLAS ===
			{ path: '/taquillas', element: <PdvConciliaList /> },
			{ path: '/taquillas/:pdv_id', element: <PdvConciliaDetail /> },
			// === TERMINALS ===
			{ path: '/terminals', element: <Catalog options={TERMINALS(user, hasAccess)} /> },
			{ path: '/terminals/:terminal_id', element: <PaymentTerminalView /> },
			
			{ path: '/config', element: <SystemConfig /> },
			{ path: '/queues', element: <ActiveQueues /> },
			{ path: '/reportes*', element: <ReportsContainer /> },
		]
	}, {
		path: '/test', 
		element: <TestScreen />
	}]);

	return Router;
}

export default RouterComponent;